import type {DocumentManager} from '@wix/document-manager-core'
import type {Experiment} from '@wix/document-services-types'
import _ from 'lodash'
import * as constants from '../../../../constants/constants'
import type {MasterPageMigrator} from '../dataMigrationRunner'
import type {DataExtensionAPI} from '../../../data'

const ATOMIC_SCOPES = constants.DATA_TYPES.atomicScopes
const ATOMIC_SCOPES_PREFIX = 'atomicScopes'
const CHUNK_SIZE = 10000

const migrateMasterPage = (dm: DocumentManager, experimentInstance: Experiment) => {
    if (!experimentInstance.isOpen('dm_cleanupAtomicScopesGarbage')) {
        return
    }

    const {data} = dm.extensionAPI as DataExtensionAPI
    const atomicScopesGarbageIds = data.queryKeys(
        ATOMIC_SCOPES,
        'masterPage',
        (value: any, key: string): boolean => value && key.startsWith(ATOMIC_SCOPES_PREFIX)
    )

    const chunkToFix = _.take(atomicScopesGarbageIds, CHUNK_SIZE)

    for (const atomicScopeId of chunkToFix) {
        dm.dal.remove(dm.pointers.getPointer(atomicScopeId, ATOMIC_SCOPES))
    }
}

const name = 'cleanupAtomicScopesGarbage'
const version = 0

const experimentalVersions = [{experiment: 'dm_cleanupAtomicScopesGarbage', version: 1}]
const disableVersioning = (documentManager: DocumentManager) => {
    const {data} = documentManager.extensionAPI as DataExtensionAPI

    const atomicScopesGarbageIds = data.queryKeys(
        ATOMIC_SCOPES,
        'masterPage',
        (value: any, key: string): boolean => value && key.startsWith(ATOMIC_SCOPES_PREFIX)
    )
    return atomicScopesGarbageIds.length > 0
}
export const cleanupAtomicScopesGarbage: MasterPageMigrator = {
    migrateMasterPage,
    name,
    version,
    disableVersioning,
    experimentalVersions
}
